/**
 * Poste suspendu dans l'ERP (statut DISABLED, decision de Mathieu du
 * 2026-10-18) : ecran plein, ventes et connexion par NIP bloquees. Rien
 * n'est efface sur le poste ; le poste se debloque seul au premier
 * battement de coeur qui dit disabled = false. Texte propose, a valider par
 * Mathieu (question ouverte de la PR 1.4).
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { palette } from './theme';

export const SUSPENDED_TEXT = 'Ce poste est suspendu. Les ventes sont bloquées jusqu\'à sa réactivation dans l\'ERP. Les données restent sur ce poste.';

export default function SuspendedScreen({ terminal }) {
    return (
        <Box
            role="alert"
            data-testid="ecran-poste-suspendu"
            sx={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: 3, p: 4, textAlign: 'center', bgcolor: palette.warningTint, color: palette.warningOnTint,
            }}
        >
            <PauseCircleOutlineIcon sx={{ fontSize: 112 }} aria-hidden="true" />
            <Typography component="h1" sx={{ fontSize: 40, fontWeight: 800 }}>Poste suspendu</Typography>
            <Typography sx={{ fontSize: 24, maxWidth: 820 }}>{SUSPENDED_TEXT}</Typography>
            {terminal && (
                <Typography sx={{ fontSize: 18 }}>
                    {[terminal.store_name, terminal.name].filter(Boolean).join(' · ')}
                </Typography>
            )}
        </Box>
    );
}
